import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiEdit, FiCheckCircle, FiClock } from 'react-icons/fi';
import { homeworkAPI } from '../../../services/api';
import { prepareHomeworkHtml } from '../../../utils/homeworkContent';
import './HomeworkPage.css';

const ViewHomeworkPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [homework, setHomework] = useState(null);
    const [students, setStudents] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadHomework();
    }, [id]);

    const loadHomework = async () => {
        try {
            setLoading(true);
            const response = await homeworkAPI.getHomework(id);
            setHomework(response.data.homework);
            setStudents(response.data.students || []);
        } catch (error) {
            console.error('Ошибка загрузки домашнего задания:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <div className="homework-loading">Загрузка...</div>;
    }

    if (!homework) {
        return <div className="homework-error">Домашнее задание не найдено</div>;
    }

    return (
        <div className="view-homework-page">
            <div className="view-homework-header">
                <button 
                    onClick={() => navigate('/admin/homework')}
                    className="btn-back"
                >
                    <FiArrowLeft />
                    Назад
                </button>
                <h1>{homework.title}</h1>
                <button
                    onClick={() => navigate(`/admin/homework/${id}/edit`)}
                    className="btn-edit-hw"
                >
                    <FiEdit />
                    Редактировать
                </button>
            </div>

            <div className="homework-info-card">
                <div className="info-row">
                    <span className="label">Создано:</span>
                    <span className="value">{new Date(homework.created_at).toLocaleString('ru-RU')}</span>
                </div>
                <div className="info-row">
                    <span className="label">Автор:</span>
                    <span className="value">{homework.created_by_name}</span>
                </div>
            </div>

            <div className="homework-content-card">
                <h2>Описание задания</h2>
                <div
                    className="homework-description-full"
                    dangerouslySetInnerHTML={{ __html: prepareHomeworkHtml(homework.description, 'admin') }}
                />
            </div>

            <div className="students-card">
                <h2>Студенты ({students.length})</h2>
                {students.length === 0 ? (
                    <p className="empty-message">Студенты не назначены</p>
                ) : (
                    <div className="students-list">
                        {students.map(student => (
                            <div key={student.id} className="student-item">
                                <button
                                    type="button"
                                    className="student-info student-info-link"
                                    onClick={() => navigate(`/admin/student/${student.id}?tab=homework`)}
                                    title="Открыть ДЗ в профиле ученика"
                                >
                                    <div className="student-name">{student.username}</div>
                                    <div className="student-email">{student.email}</div>
                                </button>
                                <div className={`student-status ${student.is_read ? 'read' : 'unread'}`}>
                                    {student.is_read ? (
                                        <>
                                            <FiCheckCircle />
                                            <span>Прочитано</span>
                                            {student.read_at && (
                                                <span className="read-date">
                                                    {new Date(student.read_at).toLocaleString('ru-RU')}
                                                </span>
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            <FiClock />
                                            <span>Не прочитано</span>
                                        </>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ViewHomeworkPage;
